var LOY = LOY || {};
	window.desktopSize = window.desktopSize || 992;
